export const captchaPuzzleActions = {
  SET_CAPTCHA_PUZZLE: "SET_CAPTCHA_PUZZLE",
}

export function CaptchaPuzzleReducer(state: any, action: any) {
  switch (action.type) {
    case captchaPuzzleActions.SET_CAPTCHA_PUZZLE:
      return { ...state, captchaPuzzle: action.value }
    default:
      return { ...state }
  }
}
